import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AppConfigService } from '../../../app-config.service';
import { BaseControlValueAccessor } from '../../classes/base-control-value-accessor';
import { InputCustomTypeEnum } from './input-custom-type.enum';
import { INPUT_MASK_CONFIGS } from './input.config';

@Component({
  selector: 'dsd-ext-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputComponent)
    }
  ],
  standalone: false
})
export class InputComponent extends BaseControlValueAccessor {
  @Input()
  identifier: string;

  @Input()
  name: string;

  @Input()
  maxLength = 9;

  @Input()
  autocomplete = 'off';

  //tslint:disable-next-line:no-input-rename
  @Input('custom-type')
  customType = InputCustomTypeEnum.Currency;

  //tslint:disable-next-line:no-input-rename
  @Input('quiet-validate')
  quietValidate: boolean;

  @Input()
  required = false;

  //tslint:disable-next-line:no-input-rename
  @Input('input-width')
  inputWidth: number;

  //tslint:disable-next-line:no-input-rename
  @Input('hide-required-labelling')
  hideRequiredLabelling = false;

  @Input()
  error: boolean;

  @Input()
  inputmode: string;

  @Input('max-decimal-length')
  maxDecimalLength: number;

  inputValue = '';

  constructor(private readonly _appConfigService: AppConfigService) {
    super();
  }

  get config() {
    return INPUT_MASK_CONFIGS[this.customType][this._appConfigService.langue];
  }

  unmaskValue(value: string): string {
    if (value !== null) {
      const sanitizedValue = this.config.sanitizeFn(value);
      return this.config.unmaskFn(sanitizedValue);
    } else {
      return '';
    }
  }

  maskValue(value: string): string {
    return this.config.maskFn(this.unmaskValue(value));
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();

    const value = event.clipboardData.getData('text/plain');
    this.updateFormValue(value);
    this.writeValue(value);
  }

  onFocusOut(value: string): void {
    this.updateFormValue(value);
    this.writeValue(value);
  }

  onKeyDown(event: KeyboardEvent) {
    // Mettre à jour le FormControl si on appuie
    // sur enter pour soumettre le formulaire
    if (event.key === 'Enter') {
      this.updateFormValue(this.inputValue);
      this.writeValue(this.inputValue);
    }
  }

  updateFormValue(value): void {
    const unsmaskedValue = this.unmaskValue(value);
    this.onChange(unsmaskedValue);
    this.onTouched(unsmaskedValue);
  }

  writeValue(value: string | number): void {
    if (value !== null && value !== undefined && value !== '') {
      this.inputValue = this.maskValue(value.toString());
    }
  }
}
